<template>
  <v-sheet tile class="fill-height" align="top">
    <v-container>
      <v-container>
        <span class="title">How it works?</span>
        <template v-if="!userIsAuthenticated || isVisitor">
          <ul>
            <li>You enter your zip code or address</li>
            <li>You select the store in which you would like to reserve a spot</li>
            <li>You select the time and date when you want to visit that store</li>
            <li>You secure your spot</li>
            <li>You visit the store and show your phone with barcode reservation generated to the store security to get
              inside without waiting in line
            </li>
          </ul>
        </template>
        <template v-else-if="isSecurity">
          <ul>
            <li>Open Scan Menu item</li>
            <li>Scan each and every user at the store</li>
            <li>Only allow these who have the right barcode determined to go inside</li>
            <li>Press Next to allow next user to come in</li>
            <li>If user scanned barcode, you pressed next, but he didn't entered the store, you wouldn't be able to scan
              his
              code again as it will be marked as user is already in store
            </li>
            <li>If you need to visit the store yourself, use switch to switch to visitor mode and open that help again
            </li>
          </ul>
        </template>
        <template v-else-if="isStoreManager">
          <ul>
            <li>Open Store menu item</li>
            <li>Use it to define who are working as a security in your store</li>
            <li>If you need to visit the store yourself, use switch to switch to visitor mode and open that help again
            </li>
            <li>If you need to work as security, use switch to switch to security mode and open that help again</li>
          </ul>
        </template>
        <template v-else-if="isBrandManager">
          <ul>
            <li>Use Store menu item to define which stores are available and who are the store managers for these stores
            </li>
            <li>You can use "Switch" menu item to act as a store manager, store security or as a regular visitor</li>
          </ul>
        </template>
        <template v-else-if="isSuperAdmin">
          <ul>
            <li>Use Brands menu item to define which brands are available and who are the brand managers for these
              stores
            </li>
            <li>You can use "Switch" menu item to act as a store manager, store security or as a regular visitor</li>
          </ul>
        </template>
        <v-btn class="mt-2 ml-6" color="primary" href="mailto:team@spot-saver.com" target="_blank">Contact us
        </v-btn>
      </v-container>

    </v-container>

  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";
  import storeDemoResult from "../../data/storedatademo";

  export default {
    name: "Help",
    computed: {
      ...mapGetters(['isVisitor', 'isSecurity', 'isStoreManager', 'isBrandManager', 'isSuperAdmin', 'userIsAuthenticated'])
    },

     mounted: function () {
      console.log("resuld data on help mount : ", storeDemoResult);
      }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Pages/Help.vue